<div mat-dialog-title>
  <div *ngIf="data.type === 'RSS_FEED'">
    <span *ngIf="isUpdate">Edit RSS Feed</span>
    <span *ngIf="!isUpdate">Add RSS Feed</span>
  </div>
  <div *ngIf="data.type === 'AUDIO_FILE'">
    <span *ngIf="isUpdate">Edit Podcast Clip</span>
    <span *ngIf="!isUpdate">Add Podcast Clip</span>
  </div>

</div>
<div mat-dialog-content>
  <form  #f="ngForm">


    <div *ngIf="data.type === 'RSS_FEED'">
      <mat-form-field floatLabel="always" class="w-100">
        <input type="text" required matInput name="url" placeholder="URL"
               [(ngModel)]="rssFeed.url">
      </mat-form-field>
    </div>
    <div *ngIf="data.type === 'AUDIO_FILE'">

      <div class="row">

        <mat-form-field floatLabel="always" class="w-100">
          <input type="text" required matInput name="seriesName" placeholder="Series Name"
                 [(ngModel)]="clip.seriesName">
        </mat-form-field>

        <mat-form-field floatLabel="always" class="w-100">
          <input type="text" required matInput name="episodeName" placeholder="Episode Name"
                 [(ngModel)]="clip.episodeName">
        </mat-form-field>

        <mat-form-field floatLabel="always" class="w-100">
          <input type="text" required matInput name="clickThroughUrl" placeholder="Click Through URL"
                 [(ngModel)]="clip.clickThroughUrl">
        </mat-form-field>

        <mat-form-field floatLabel="always" class="w-100">
          <input type="text" required matInput [formControl]="myControl" [matAutocomplete]="auto4" [(ngModel)]="clip.channelLanguage" placeholder="Language"/>
          <mat-icon matSuffix>keyboard_arrow_down</mat-icon>

          <mat-autocomplete autoActiveFirstOption  #auto4="matAutocomplete" (optionSelected)="onFilterOptionSelected($event)" [displayWith]="this.displayFn.bind(this)">
            <mat-option *ngFor="let option of filteredLanguageCodes | async | keyvalue" [value]="option.key">
              {{option.value}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <div *ngIf="!isUpdate">
          <mat-form-field style="width: 100%;">
            <mat-label>Audio File</mat-label>
            <button mat-icon-button matPrefix (click)="audio_input.click()">
              <mat-icon>attach_file</mat-icon>
            </button>
            <input type="text" readonly [required]="!isUpdate" matInput accept="audio/*" [formControl]="audioDisplay"/>
            <input
              type="file"
              multiple
              hidden
              [required]="!isUpdate"
              accept=".mp3"
              #audio_input
              (change)="handleAudioFileInputChange(audio_input.files)"
            />
            <mat-error>this field is required</mat-error>
          </mat-form-field>
          <mat-form-field style="width: 100%;">
            <mat-label>Image File</mat-label>
            <button mat-icon-button matPrefix (click)="video_input.click()">
              <mat-icon>attach_file</mat-icon>
            </button>
            <input type="text" readonly matInput accept="image/png, image/jpeg" [formControl]="imageDisplay"/>
            <input
              type="file"
              multiple
              accept="image/png, image/jpeg"
              hidden
              [required]="!isUpdate"
              #video_input
              (change)="handleImageFileInputChange(video_input.files)"
            />
            <mat-error>this field is required</mat-error>
          </mat-form-field>

        </div>

        <table *ngIf="isUpdate">
          <tr>
            <th style="min-width:280px"></th>
            <th style="min-width:280px"></th>
          </tr>
          <tr>
            <td>
              <mat-form-field style="width: 100%;">
                <mat-label>Audio File</mat-label>
                <button mat-icon-button matPrefix (click)="audio_input.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                <input type="text" readonly [required]="!isUpdate" matInput accept="audio/*" [formControl]="audioDisplay"/>
                <input
                  type="file"
                  multiple
                  hidden
                  [required]="!isUpdate"
                  accept=".mp3"
                  #audio_input
                  (change)="handleAudioFileInputChange(audio_input.files)"
                />
                <mat-error>this field is required</mat-error>
              </mat-form-field>
            </td>
            <td>
              <audio controls><source [src]="clip.audioUrl" type="audio/mpeg" /></audio>
            </td>
          </tr>
          <tr>
            <td >
              <mat-form-field style="width: 100%;">
                <mat-label>Image File</mat-label>
                <button mat-icon-button matPrefix (click)="video_input.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                <input type="text" readonly matInput accept="image/png, image/jpeg" [formControl]="imageDisplay"/>
                <input
                  type="file"
                  multiple
                  accept="image/png, image/jpeg"
                  hidden
                  [required]="!isUpdate"
                  #video_input
                  (change)="handleImageFileInputChange(video_input.files)"
                />
                <mat-error>this field is required</mat-error>
              </mat-form-field>
            </td>
            <td style="width:50%">
              <img style="width: 50px" [src]="clip.imageUrl" />
            </td>
          </tr>
        </table>





      </div>

    </div>


  </form>

</div>
<div mat-dialog-actions class="justify-content-center">
  <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button class="iconed" color="primary" [disabled]="!f.valid" (click)="saveClip()" *ngIf="data.type === 'AUDIO_FILE'">
    <i class="far fa-save"></i>
    <span>Save</span>
  </button>
  <button mat-raised-button class="iconed" color="primary" [disabled]="!f.valid" (click)="saveFeed()" *ngIf="data.type === 'RSS_FEED'">
    <i class="far fa-save"></i>
    <span>Save</span>
  </button>
</div>
